import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Navigation from './navigation'
import Styles from './styles'
import * as pageActions from '../store/page'
import Y from '../y18n'

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  pageActions: bindActionCreators(pageActions, dispatch)
})

class NavigationAppShell extends Component {
  componentDidMount () {
    this.props.pageActions.setPageName(Y`${this.props.pageName}`)
  }

  render () {
    const { classes } = this.props
    return (
      <div className={classes.rootContainer}>
        <div className={'container'}>
          <Navigation />
          <div className={'main'}>
            <div className={'mainContent'}>
              {this.props.content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

NavigationAppShell = connect(mapStateToProps, mapDispatchToProps)(NavigationAppShell)
export default withStyles(Styles)(NavigationAppShell)



// WEBPACK FOOTER //
// ./src/common/navigation-app-shell.js